import { createSlice } from '@reduxjs/toolkit';

import { getLastSync, startSync } from './actions';
import { INITIAL_STATE } from './constants';
import {
    getLastSyncFulfilledReducer,
    getLastSyncPendingReducer,
    getLastSyncRejectedReducer,
    setProcessingReducer,
    startSyncFulfilledReducer,
    startSyncPendingReducer,
    startSyncRejectedReducer
} from './reducers';

export const jamfSyncSlice = createSlice({
  name: 'jamfSyncSlice',
  initialState: INITIAL_STATE(),
  reducers: {
    setProcessingReducer,
    resetState: () => INITIAL_STATE(),
  },
  extraReducers: (builder) => {
    builder.addCase(getLastSync.pending, getLastSyncPendingReducer);
    builder.addCase(getLastSync.fulfilled, getLastSyncFulfilledReducer);
    builder.addCase(getLastSync.rejected, getLastSyncRejectedReducer);
    
    builder.addCase(startSync.pending, startSyncPendingReducer);
    builder.addCase(startSync.fulfilled, startSyncFulfilledReducer);
    builder.addCase(startSync.rejected, startSyncRejectedReducer);
  },
});

const { setProcessingReducer: setProcessing, resetState } = jamfSyncSlice.actions;

export { getLastSync, resetState, setProcessing, startSync };

